import Stack from "@mui/material/Stack";
import { type RawDraftContentState } from "draft-js";
import React, { FC } from "react";
import DraftEditor from "shared/components/DraftEditor";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import { COLOR_BLACK } from "shared/theme/colors";
import { LocaleCode } from "shared/types/languages";
import { useFaqDetails } from "../../../../context";

const Translations: FC = () => {
  const {
    questionInput,
    translations,
    setTranslations,
    handleTranslationEditorChange,
  } = useFaqDetails();

  const handleChangeQuestion = (field: string, value: string) => {
    setTranslations({
      ...translations,
      [LocaleCode.ja]: {
        ...(translations?.[LocaleCode.ja] || {}),
        [field]: value,
      },
    });
  };

  return (
    <ContentSection title="Translations Japanese">
      <Stack spacing={2}>
        <TextField
          id="question"
          label="Question"
          placeholder="Click here to edit text"
          fullWidth
          value={translations?.ja?.Question}
          onChange={(e) => handleChangeQuestion("Question", e.target.value)}
          errors={questionInput?.input.errors}
          labelColor={COLOR_BLACK}
        />
        <DraftEditor
          content={
            (
              translations?.ja?.Answer as {
                editorContent?: RawDraftContentState;
              }
            )?.editorContent || null
          }
          label="Answer"
          onChange={(content) =>
            handleTranslationEditorChange(LocaleCode.ja, content)
          }
          placeholder="Click here to edit text"
          hasHeadingToolbars
          hasListToolbars
          hasImageUpload
          entityName="faq"
        />
      </Stack>
    </ContentSection>
  );
};

export default Translations;
